import { Product } from 'framework/api/models/product';
import { Kubo } from 'framework/api/models/kubo';
import { validateProduct } from 'framework/api/dto/product/common';
import { validKubo } from 'framework/api/dto/kubo/common';

export function validGetInvitationById(dtoRes: any): Kubo | Product {
    return 'owner' in dtoRes ? validKubo(dtoRes) : validateProduct(dtoRes);
}
